var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticStyle:{"height":"calc(100vh - 100px)"},attrs:{"elevation":"2"}},[_c('v-card-text',[_vm._v("Страница не найдена. Page not found. (NotFoundComponent)")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }